import { type FC } from 'react'
import { observer } from 'mobx-react-lite'
import { IconButton, type IIconButtonProps } from 'shared/ui'
import { ZIndex } from 'shared/constants/zIndex'
import { useCallPopUpDefaultContext } from 'widgets/CallPopUp/context/callPopUpDefaultContext'
import styles from './styles.module.scss'

export const CallMicPopUpIncomingButton: FC<Partial<IIconButtonProps>> = observer((props) => {
  const store = useCallPopUpDefaultContext()
  const { isIncomingMute, handleIncomingMute, isIncomingMuteDisabled, innerRefTooltipCurrent } =
    store

  return (
    <div className={styles.wrap}>
      <IconButton
        size={'large'}
        color={'blue'}
        variant={'custom'}
        active={isIncomingMute}
        onClick={() => {
          handleIncomingMute()
        }}
        ariaLabel={`CallMicPopUpIncomingButton_${isIncomingMute ? 'unmute' : 'mute'}`}
        disabled={isIncomingMuteDisabled}
        iconProps={{
          icon: isIncomingMute ? 'volumeMute' : 'volumeMax',
        }}
        tooltipProps={{
          zIndex: ZIndex.OVERLAY_TOP_1,
          label: isIncomingMute ? 'Unmute' : 'Mute',
          placement: 'top',
          PopperProps: {
            popperOptions: {
              modifiers: [
                {
                  name: 'preventOverflow',
                  options: {
                    boundary: innerRefTooltipCurrent,
                  },
                },
              ],
            },
          },
        }}
        {...props}
      />
    </div>
  )
})
